/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, Image, TouchableHighlight, StyleSheet } from 'react-native'
import styles from './Styles/MessageComponentStyle'
import { ButtonGroup, ListItem } from "react-native-elements"
// import FastImage from 'react-native-  fast-image' // https://github.com/DylanVann/react-native- fast-image
//import FastImage from '../Components/FastImage'
import { getAvatar } from '../Lib/utils'
import MessageCard from '../Components/MessageCard.js';
import Images from "../Themes/Images"
import AvatarComponent from './AvatarComponent'
import TextComponent from './TextComponent'
import UserActions from "../Redux/UserRedux"
import { connect } from 'react-redux'
class MessageCacheComponent extends Component {
  constructor(props) {
    super(props)
    this.containerStyle = {
      height: 55,
      overflow: 'hidden',
      flex: 1,
      flexDirection: `row` ,
      paddingTop: 10,
      paddingLeft: 10,
      paddingRight: 10,
      justifyContent: `space-between`,
      backgroundColor: `#FFFFFF`}
    this.avatarStyle = { borderWidth : 0}
    this.centerStyle = { flex: 1 , height: 34, justifyContent:'center'}
    this.titleStyle = [styles.title, this.props.titleStyle, {paddingLeft:  14, marginLeft: 0}]
    this.subTitleStyle = [styles.subTitle,this.props.subtitleStyle, {paddingLeft:  14, marginLeft: 0}]
    this.rightStyle = { marginLeft: 10, height: 44 , width: 30, marginRight: 10, paddingTop: 8}
    this.rightTextStyle = [styles.rightTitle, this.props.rightTitleStyle]
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.userId != nextProps.userId ||
      this.props.title != nextProps.title ||
      this.props.subTitle != nextProps.subTitle ||
      this.props.rightTitle != nextProps.rightTitle ||
      this.props.refreshAvatar != nextProps.refreshAvatar)
        return true
    return false
  }

  render() {
    const { userId = '', subTitle = '', rightTitle = '' } = this.props

    // not ideal but we will put first pre-comma as bold (biz name)
    // if biz name has a comma, well...
    let splitLocationByComma = subTitle ? subTitle.split(',') : ['', '']
    let apparentBizName = (splitLocationByComma.length > 0) ? splitLocationByComma[0] : ''
    splitLocationByComma.shift() // remove the item we used
    let restOfAddress = (splitLocationByComma.length > 0) ? splitLocationByComma.join(',') : ''
    restOfAddress = restOfAddress.trim() // get rid of leading blank
    return (
      <View style={this.containerStyle}>
        <AvatarComponent
          style={this.avatarStyle}
          userId={this.props.userId}
          onPress={this.props.onPress}
          size={34} />
        <View style={this.centerStyle}>
          <Text style={this.titleStyle} onPress={this.props.onPress}>{this.props.title}</Text>
          {!!apparentBizName && apparentBizName.length > 0 && <TextComponent numberOfLines={1} style={[this.subTitleStyle, {fontWeight: 'bold'}]} onPress={this.props.onSubTitle} text={apparentBizName} />}
          {!!restOfAddress && restOfAddress.length > 0 && <TextComponent numberOfLines={1} style={this.subTitleStyle} onPress={this.props.onSubTitle} text={restOfAddress} />}
        </View>
        <View style={this.rightStyle}>
          {!!rightTitle && rightTitle.length > 0 && <Text style={this.rightTextStyle}>{rightTitle}</Text>}
        </View>
      </View>
    )
  }
}

// if any place in the app mods the refreshAvatar property of user redux, this component will render
const mapStateToProps = state => {
  return {
    refreshAvatar: state.user.refreshAvatar
  }
}

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(MessageCacheComponent)
